import React from 'react';

type Issue = {
  key: string;
  summary: string;
};

type Props = {
  issues: Issue[];
  missingKeys: string[];
};

const IssuesList: React.FC<Props> = ({ issues, missingKeys }) => (
  <ul>
    {issues.map((issue) => (
      <li key={issue.key} style={missingKeys.includes(issue.key) ? { color: 'red' } : {}}>
        {issue.key} - {issue.summary}
      </li>
    ))}
  </ul>
);

export default IssuesList;
